import { yupResolver } from '@hookform/resolvers/yup';
import { useGoogleLogin } from '@react-oauth/google';
import LogoImg from 'assets/images/logo_login.png';
import WaveBackground from 'assets/images/wave_background.png';
import { notify } from 'components/ToastNotification/ToastNotification';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import LocalStorageManager from 'services/LocalStorageManager/LocalStorageManager';
import paths from 'shared/paths';
import {
    useLoginWithGoogleMutation,
    useLoginWithPasswordMutation,
} from 'src/graphql/generated';
import { ToastTypes } from 'types/CommonTypes';
import {
    ExternalLinkWrapper,
    FormWrapper,
    Logo,
    PageBox,
    PageWrapper,
    SecondaryText,
    StyledButton,
    StyledInput,
    StyledLink,
    Text,
    WaveWrapper,
} from '../SharedLogin.styled';
import { validationLogin } from '../validations';

interface LoginFormInputs {
    email: string;
    password: string;
}

export const LoginPage = () => {
    const history = useHistory();
    const redirectUri = window.location.origin;
    const {
        control,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm<LoginFormInputs>({ resolver: yupResolver(validationLogin) });

    const [loginWithGoogle, { loading }] = useLoginWithGoogleMutation();
    const [loginWithPassword, { loading: loadingWithPassword }] =
        useLoginWithPasswordMutation();

    const login = useGoogleLogin({
        flow: 'auth-code',
        onSuccess: async (response) => {
            try {
                LocalStorageManager.setValue('O-Auth2-Code', response.code);
                LocalStorageManager.setValue(
                    'X-Redirect-Url',
                    process.env.GOOGLE_REDIRECT_URI ?? redirectUri,
                );
                loginWithGoogle({
                    onCompleted: (data) => {
                        LocalStorageManager.setValue(
                            'X-Session-Token',
                            data.loginWithGoogle,
                        );
                        history.push(paths.home);
                        return notify('Logowanie przebiegło pomyślnie')[
                            ToastTypes.SUCCESS
                        ]();
                    },
                });
            } catch (err) {
                console.log(err);
                return notify('Coś poszło nie tak, error: ' + err)[
                    ToastTypes.ERROR
                ]();
            }
        },
    });

    const onSubmit = async (data: LoginFormInputs) => {
        try {
            const response = await loginWithPassword({
                variables: {
                    credentials: { email: data.email, password: data.password },
                },
            });
            if (response.data?.loginWithPassword) {
                LocalStorageManager.setValue(
                    'X-Session-Token',
                    response.data.loginWithPassword,
                );
                history.push(paths.home);
                notify('Logowanie przebiegło pomyślnie')[ToastTypes.SUCCESS]();
            } else {
                throw new Error('Nieprawidłowe dane logowania');
            }
        } catch (error) {
            const errorMessage =
                error instanceof Error ? error.message : 'Nieznany błąd';
            notify('Błąd logowania: ' + errorMessage)[ToastTypes.ERROR]();
        }
    };

    return (
        <PageWrapper>
            <StyledLink to={paths.login}>
                <Logo src={LogoImg} />
            </StyledLink>
            <WaveWrapper src={WaveBackground} />
            <PageBox>
                <FormWrapper onSubmit={handleSubmit(onSubmit)}>
                    <StyledInput
                        control={control}
                        errors={errors.email}
                        name={'email'}
                        placeholder={'Email'}
                        type={'text'}
                        marginBottom={30}
                        iconType={'Email'}
                    />
                    <StyledInput
                        control={control}
                        errors={errors.password}
                        name={'password'}
                        placeholder={'Hasło'}
                        type={'password'}
                        iconType={'Password'}
                    />

                    {/*<ForgotPasswordText to={paths.reset_password}>
                        Zapomniałeś hasła?
                    </ForgotPasswordText>*/}

                    <StyledButton
                        buttonType="black"
                        disabled={isSubmitting || loadingWithPassword}
                        type="submit"
                    >
                        {isSubmitting || loadingWithPassword
                            ? 'logowanie się...'
                            : 'zaloguj się'}
                    </StyledButton>
                </FormWrapper>

                {/*<AnotherText>możesz kontynuować za pomocą</AnotherText>

                <StyledGoogleButton
                    disabled={loading}
                    buttonType={'grey'}
                    onPress={login}
                >
                    <IconManager cursorPointer name={'GoogleLoginLogo'} />
                </StyledGoogleButton>*/}
                <Text>Logując się akceptujesz</Text>
                <SecondaryText>
                    <ExternalLinkWrapper
                        href={paths.service_rules}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Zasady usługi
                    </ExternalLinkWrapper>
                    i
                    <ExternalLinkWrapper
                        href={paths.privacy_policy}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Politykę prywatności
                    </ExternalLinkWrapper>
                </SecondaryText>
                {/*<Text>
                    Nie masz jeszcze konta ?
                    <LinkWrapper to={paths.sign_up}>
                        Zarejestruj się
                    </LinkWrapper>
                </Text>*/}
            </PageBox>
        </PageWrapper>
    );
};
